module.exports = __webpack_public_path__ + "assets/img/e1.814d6b31.jpg";